import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as Sentry from '@sentry/react';
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  whitelist: ['auth'],
  storage,
};

const rootReducer = combineReducers(reducers);

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = createStore(
  persistedReducer,
  compose(applyMiddleware(thunk), sentryReduxEnhancer)
);
export const persistor = persistStore(store);

export type IRootState = ReturnType<typeof rootReducer>;
